import React, { useState } from 'react';
import Auth from './components/Auth';
import AdminApp from './components/AdminApp';
import ApiService from './components/ApiService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);

  const handleAuthenticated = (jwtToken) => {
    setToken(jwtToken);
    ApiService.setToken(jwtToken);
    setIsAuthenticated(true);
  };

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Auth onAuthenticated={handleAuthenticated} />
      ) : (
        <AdminApp token={token} />
      )}
    </div>
  );
}

export default App;